<template>
  <a-layout>
    <HeaderTop />
    <a-layout>
      
       <HeaderPage indexmenu="RengongYlqRw" />
      <a-layout style="padding: 0px 12px 24px;background: #fff;margin-left: 12px;border-radius: 8px;">
        <a-layout-content> <RengongYlqRwKF2025Content msg=""/> </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
// @ is an alias to /src
import HeaderPage from '@/components/HeaderPage.vue'
import HeaderTop from '@/components/HeaderTop.vue'

import RengongYlqRwKF2025Content from '@/components/rengongcuiping/RengongYlqRwKF2025Content.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderPage,
    HeaderTop,
    RengongYlqRwKF2025Content
  },
  data(){
    return {
    }
  }
}
</script>
